module.exports = __webpack_public_path__ + "img/map_3.e5be866e.jpg";